import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { ICON_STROKE } from "../../ui/icon";

const PublicCollapsibleSection = ({
  title,
  defaultOpen = false,
  children,
  className = "",
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={`pub-collapse ${className}`}>
      <button
        type="button"
        className="pub-collapse__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <h2 className="pub-section-title pub-section-title--inline">{title}</h2>
        {open ? (
          <ChevronUp size={20} strokeWidth={ICON_STROKE} aria-hidden />
        ) : (
          <ChevronDown size={20} strokeWidth={ICON_STROKE} aria-hidden />
        )}
      </button>
      {open && <div className="pub-collapse__body">{children}</div>}
    </section>
  );
};

export default PublicCollapsibleSection;
